// Cold supply-chain specific imagery (Unsplash)
const q = "?auto=format&fit=crop&q=80&w=1600";

export const IMAGES = {
  coldWarehouse: `https://images.unsplash.com/photo-1684695749267-233af13276d0${q}`,
  forkliftYellow: `https://images.unsplash.com/photo-1532635042-a6f6ad4745f9${q}`,
  coldRacks: `https://images.unsplash.com/photo-1622030411594-c282a63aa1bc${q}`,
  coldWarehouseCyan: `https://images.unsplash.com/photo-1627309366653-2dedc084cdf1${q}`,
  reeferTruck: `https://images.unsplash.com/photo-1616432043562-3671ea2e5242${q}`,
  reeferTruck2: `https://images.unsplash.com/photo-1592838064575-70ed626d3a0e${q}`,
  frozenStacks: `https://images.unsplash.com/photo-1710141530542-f792450e736e${q}`,
  frozenFood: `https://images.unsplash.com/photo-1651383140368-9b3ee59c2981${q}`,
  freezerAisle: `https://images.unsplash.com/photo-1613083042976-463bdde9ec51${q}`,
};
